import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeclarationForm = _resolveComponent("DeclarationForm")!
  const _component_DocumentDeclaration = _resolveComponent("DocumentDeclaration")!
  const _component_DeclarationManager = _resolveComponent("DeclarationManager")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.declaration && ['EDITION'].includes(_ctx.declaration.status))
      ? (_openBlock(), _createBlock(_component_DeclarationForm, {
          key: 0,
          declaration: _ctx.declaration,
          formId: _ctx.declaration.form.id,
          "hide-header": _ctx.header,
          decId: _ctx.decId,
          cerfaNumber: _ctx.declaration.form.cerfaNumber,
          onDeclarationSent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh()))
        }, null, 8, ["declaration", "formId", "hide-header", "decId", "cerfaNumber"]))
      : (_ctx.declaration && _ctx.declaration.form)
        ? (_openBlock(), _createBlock(_component_DocumentDeclaration, {
            key: 1,
            declaration: _ctx.declaration,
            formId: _ctx.declaration.form.id,
            onUpdateDeclarationStatus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh()))
          }, null, 8, ["declaration", "formId"]))
        : (_ctx.declaration)
          ? (_openBlock(), _createBlock(_component_DeclarationManager, {
              key: 2,
              id: _ctx.decId,
              propsCerfaNumber: _ctx.cerfaNumber,
              propsStartDate: _ctx.declaration.startDate,
              propsEndDate: _ctx.declaration.endDate,
              onUpdateDeclarationStatus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refresh()))
            }, null, 8, ["id", "propsCerfaNumber", "propsStartDate", "propsEndDate"]))
          : _createCommentVNode("", true)
  ]))
}